import {
  ACCTAG_LOADING,
  GET_ACCTAG,
  GET_ACCTAG_SUCCESS,
  GET_ACCTAG_FAIL,
  ADD_ACCTAG_SUCCESS,
  ADD_ACCTAG_FAIL,
  DELETE_ACCTAG_SUCCESS,
  DELETE_ACCTAG_FAIL,
  UPDATE_ACCTAG_SUCCESS,
  UPDATE_ACCTAG_FAIL
} from "./actionType";

const INIT_STATE = {
  accTags: [],
  error: {},
};

const AccTag = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ACCTAG_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ACCTAG:
          return {
            ...state,
            accTags: action.payload.data,
            isAccTagCreated: false,
            isAccTagSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_ACCTAG_FAIL:
      switch (action.payload.actionType) {
        case GET_ACCTAG_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAccTagCreated: false,
            isAccTagSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_ACCTAG: {
      return {
        ...state,
        isAccTagCreated: false,
        loading: true,
      };
    }

    case ACCTAG_LOADING: {
      return {
        ...state,
        isAccTagCreated: false,
        loading: true,
      };
    }

    case ADD_ACCTAG_SUCCESS:
      return {
        ...state,
        isAccTagCreated: true,
        loading: false,
        accTags: [action.payload.data, ...state.accTags],
      };

    case ADD_ACCTAG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_ACCTAG_SUCCESS:
      return {
        ...state,
        loading: false,
        accTags: state.accTags.filter(
          accTag => accTag.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_ACCTAG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ACCTAG_SUCCESS:
      return {
        ...state,
        loading: false,
        accTags: state.accTags.map(accTag =>
          accTag.id.toString() === action.payload.data.id.toString() ? { ...accTag, ...action.payload.data } : accTag
        ),
      };

    case UPDATE_ACCTAG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return { ...state };
  }
};

export default AccTag;